import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-minimal-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './minimal-layout.html',
  styleUrl: './minimal-layout.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MinimalLayoutComponent {}
